document.addEventListener('DOMContentLoaded', function () {
    const collapsibleBlocks = document.querySelectorAll('.product-collapsible-block');

    collapsibleBlocks.forEach(block => {
        const trigger = block.querySelector('[data-action="toggle-collapsible"]');
        const content = block.querySelector('.collapsible-content');
        const openByDefault = trigger.classList.contains('is-open');
        const pageContent = block.querySelector('.page-content');


        // Initial open logic
        if (((pageContent && pageContent.innerHTML.trim()) || content && content.innerText.trim()) !== '' && openByDefault) {
            trigger.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            content.classList.remove('is-hidden');
            content.classList.add('is-open');
            content.style.maxHeight = 'unset';
                } 
        trigger.addEventListener('click', function (event) {
            event.preventDefault();
            const isOpen = this.classList.contains('is-open');
            this.classList.toggle('is-open');
            content.classList.toggle('is-hidden');
            content.classList.toggle('is-open');
            content.style.maxHeight = isOpen ? null : content.scrollHeight + 'px';
        });
    });

    // Debounce function (move this here as well)
    function debounce(func, delay) {
        let timeoutId;
        return function (...args) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    }
});